import api from './api';

export const customerService = {
  getAll: (params = {}) => api.get('/customers/', { params }),
  getById: (id) => api.get(`/customers/${id}`),
  create: (data) => api.post('/customers/', data),
  update: (id, data) => api.put(`/customers/${id}`, data),
  delete: (id) => api.delete(`/customers/${id}`),
  getProjects: (id) => api.get(`/customers/${id}/projects`),
  addNote: (id, note) => api.post(`/customers/${id}/notes`, note),
  deleteNote: (id, noteIndex) => api.delete(`/customers/${id}/notes/${noteIndex}`),
  addContactLog: (id, contactLog) => api.post(`/customers/${id}/contact-logs`, contactLog),
  updateContactLog: (id, logIndex, contactLog) => api.put(`/customers/${id}/contact-logs/${logIndex}`, contactLog),
  deleteContactLog: (id, logIndex) => api.delete(`/customers/${id}/contact-logs/${logIndex}`),
  addAppointment: (id, appointment) => api.post(`/customers/${id}/appointments`, appointment),
  updateAppointment: (id, appointmentTitle, appointment) => api.put(`/customers/${id}/appointments/${encodeURIComponent(appointmentTitle)}`, appointment),
  deleteAppointment: (customerId, appointmentTitle) => api.delete(`/customers/${customerId}/appointments/${encodeURIComponent(appointmentTitle)}`),
  getStats: () => api.get('/customers/stats/overview'),
};
